import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import AuthService from "../services/ads.service";

export const addAds = createAsyncThunk(
  "ads/add",
  async ({ adId, slot, type, location, isActive }, thunkAPI) => {
    try {
      const data = await AuthService.addAds(
        adId,
        slot,
        type,
        location,
        isActive
      );
      thunkAPI.dispatch(setMessage(data.message));
      return true;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getAds = createAsyncThunk("ads/get", async (thunkAPI) => {
  try {
    const data = await AuthService.getAds();
    return data.docs;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue();
  }
});

export const updateAds = createAsyncThunk(
  "ads/update",
  async ({ id, location, isActive }, thunkAPI) => {
    try {
      const data = await AuthService.updateAds(id, location, isActive);
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateAdsData = createAsyncThunk(
  "ads/updateInfo",
  async ({ id, adId, slot, type, location, isActive }, thunkAPI) => {
    try {
      const data = await AuthService.updateAdsData(
        id,
        adId,
        slot,
        type,
        location,
        isActive
      );
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteAds = createAsyncThunk(
  "ads/delete",
  async (id, thunkAPI) => {
    try {
      const data = await AuthService.deleteAds(id);
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = { isLoader: false, advertise: null };

const adsSlice = createSlice({
  name: "advertisement",
  initialState,
  extraReducers: {
    [addAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.advertise = null;
    },
    [addAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.advertise = null;
    },
    [getAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.advertise = action.payload;
    },
    [getAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.advertise = null;
    },
    [updateAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.advertise = action.payload;
    },
    [updateAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.advertise = null;
    },
    [updateAdsData.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.advertise = action.payload;
    },
    [updateAdsData.rejected]: (state, action) => {
      state.isLoader = false;
      state.advertise = null;
    },
    [deleteAds.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.advertise = action.payload;
    },
    [deleteAds.rejected]: (state, action) => {
      state.isLoader = false;
      state.advertise = null;
    },
  },
});

const { reducer } = adsSlice;
export default reducer;
